import React from 'react'

const SITE_DOMAIN = 'https://slite.com'

export function absoluteUrl(path: string): string {
  return `${SITE_DOMAIN}${path.startsWith('/') ? path : `/${path}`}`
}

export function JsonLd({ data }: { data: object }) {
  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Static JSON-LD structured data, no user input
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  )
}

export function softwareApplicationSchema({
  name,
  description,
  url,
  imageUrl,
  applicationCategory = 'BusinessApplication',
}: {
  name: string
  description: string
  url: string
  imageUrl?: string
  applicationCategory?: string
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    url,
    ...(imageUrl ? { image: imageUrl } : {}),
    applicationCategory,
    operatingSystem: 'Web',
  }
}

export function itemListSchema({
  items,
}: {
  items: { name: string; url: string }[]
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      url: item.url,
    })),
  }
}

export function breadcrumbSchema({
  items,
}: {
  items: { name: string; url: string }[]
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  }
}
